/**
 * Created by weid on 2017/9/10.
 */
/**
 * 包装 reducer，解决重复劳动
 * 示例参考 rootRedux/reducers/userInfo.js
 *
 * @param initialState      initialState
 * @param ACTION_HANDLERS   reducer
 * @returns {Function}      reducer
 */

export default function reducerGenerator(initialState = {}, ACTION_HANDLERS) {
    return function inner(state = initialState, action) {
        const handler = ACTION_HANDLERS[action.type];
        return handler ? handler(state, action) : state;
    };
}



// WEBPACK FOOTER //
// ./src/rootRedux/extensions/reducerGenerator.js